var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_vm._v(_vm._s(_vm.$t("dashboard.report_performance")))]),_c('div',{ref:"chartdiv",staticStyle:{"height":"300px"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }